import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import 'bootswatch/dist/materia/bootstrap.min.css';
import Dashboard from "./components/Dashboard";
import Inventory from "./components/Inventory";
import POS from "./components/POS";
import Login from "./components/Login";
import Logout from "./components/Logout";
import ProtectedRoute from "./components/ProtectedRoute"; // Import ProtectedRoute
import Navbar from "./components/Navbar"; // Import Navbar component
import SalesHistory from "./components/SalesHistory";

function App() {
  return (
    <div className="App">
      <Router>
        {/* Conditionally render the Navbar */}
        <Navbar />

        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pos"
            element={
              <ProtectedRoute>
                <POS />
              </ProtectedRoute>
            }
          />

          <Route
            path="/saleshistory"
            element={
              <ProtectedRoute>
                <SalesHistory />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
